import * as React from 'react';
import { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { TableComponent } from 'views/versions/component/TableComponent';
import { AssumptionQuestionModal } from 'views/versions/component/AssumptionQuestionModal';
import { Box } from '@mui/material';
import Swal from 'sweetalert2';
import AddIcon from '@mui/icons-material/Add';
import axiosInstance from 'interceptors/axiosInstance';
import { getQuestionDataAPI, insertUpdateQuestionAPI, deleteQuestionAPI } from 'api/api';
import Notification from 'ui-component/notification/notification';
import AnswerModel from './AnswerModel';

function Question({ view, initialRows, ClientId, ProjectId, EstimationId, Version, setDirty, setNotDirty }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(initialRows);

  const columns = ['', 'Question', 'Added BY', 'Added On'];
  const [rowToEdit, setRowToEdit] = useState(null);
  const [refreshRows, setRefreshRows] = useState(0);
  const [openNotification, setOpenNotification] = useState(false);
  const [openAsnwerPopup, setOpenAnswerPopup] = useState(false);

  const handleDeleteRow = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axiosInstance
          .delete(deleteQuestionAPI, {
            data: { QuestionId: id, ClientId: ClientId, ProjectID: ProjectId, EstimationId: EstimationId, Version: Version }
          })
          .catch((error) => console.log(error));
        setRows(rows.filter((r) => r.QuestionId !== id));
        setRefreshRows(refreshRows + 1);
      }
    });
  };

  const handleEditRow = (idx) => {
    setRowToEdit(idx);
    setOpen(true);
  };

  const handleAnswerPopup = (idx) => {
    setRowToEdit(idx);
    setOpenAnswerPopup(true);
  }

  const handleSave = async (updatedRow) => {
    await axiosInstance
      .post(insertUpdateQuestionAPI, updatedRow)
      .then((response) => {
        if (response.status === 200) {
          setOpenNotification(true);
          setNotDirty();
        }
      })
      .catch((error) => console.log(error));
  };

  const handleOnDragEnd = async (result) => {
    if (!result.destination) return;
    const items = Array.from(rows);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const updatedItems = items.map((item, index) => ({
      QuestionId: item.QuestionId,
      Question: item.Question,
      QuestionOrder: index + 1,
      Updated: item.Updated,
      UpdatedBy: item.UpdatedBy,
      Added: item.Added,
      AddedBy: item.AddedBy,
      EstimationID: EstimationId,
      Answer: item.Answer,
      Version: Version,
      ProjectID: ProjectId,
      ClientID: ClientId
    }));
    for (let i = 0; i < updatedItems.length; i++) {
      if (updatedItems[i].QuestionId !== rows[i].QuestionId) {
        setDirty();
        break;
      }
    }
    setRows(updatedItems);
  };

  const handleSubmit = async (newRow) => {
    if (rowToEdit === null) {
      await axiosInstance
        .post(insertUpdateQuestionAPI, [
          {
            QuestionId: newRow.QuestionId,
            Question: newRow.Question,
            QuestionOrder: newRow.QuestionOrder,
            Answer: newRow.Answer,
            ClientId: ClientId,
            ProjectID: ProjectId,
            EstimationId: EstimationId,
            Version: Version
          }
        ])
        .catch((error) => console.log(error));
      setRows([...rows, newRow]);
    } else {
      await axiosInstance
        .post(insertUpdateQuestionAPI, [
          {
            QuestionId: newRow.QuestionId,
            Question: newRow.Question,
            QuestionOrder: newRow.QuestionOrder,
            Answer: newRow.Answer,
            ClientId: ClientId,
            ProjectID: ProjectId,
            EstimationId: EstimationId,
            Version: Version
          }
        ])
        .catch((error) => console.log(error));
      setRows(
        rows.map((currRow, idx) => {
          if (idx !== rowToEdit) return currRow;
          return newRow;
        })
      );
    }
    setRefreshRows(refreshRows + 1);
  };

  useEffect(() => {
    const fetchRows = async () => {
      await axiosInstance
        .get(`${getQuestionDataAPI}?ClientId=${ClientId}&ProjectID=${ProjectId}&EstimationId=${EstimationId}&Version=${Version}`)
        .then((response) => {
          setRows([...response.data]);
        })
        .catch((error) => console.log(error));
    };
    fetchRows();
  }, [refreshRows]);

  return (
    <Box>
      <Button
        style={{ visibility: view ? 'hidden' : 'visible' }}
        size="1.3rem"
        type="button"
        variant="contained"
        color="secondary"
        onClick={() => setOpen(true)}
      >
        <>
          <AddIcon />
          Add
        </>
      </Button>

      <TableComponent
        view={view}
        rows={rows}
        columns={columns}
        deleteRow={handleDeleteRow}
        editRow={handleEditRow}
        onDragEnd={handleOnDragEnd}
        isDraggable={true}
        isNewEstimate={true}
        handleAnswerPopup={handleAnswerPopup}
      />
      <Notification openNotification={openNotification} setOpenNotification={setOpenNotification} message={'Saved Successfully'} />
      <Button
        size="1.3rem"
        type="button"
        variant="contained"
        color="secondary"
        sx={{ marginTop: '20px', visibility: view ? 'hidden' : 'visible' }}
        onClick={() => handleSave(rows)}
      >
        Save
      </Button>

      <AssumptionQuestionModal
        column1={'question'}
        open={open}
        closeModal={() => {
          setOpen(false);
          setRowToEdit(null);
        }}
        onSubmit={handleSubmit}
        defaultValue={rowToEdit !== null && rows[rowToEdit]}
      />

      <AnswerModel openAsnwerPopup={openAsnwerPopup} closeAnswerPopup={() => {setOpenAnswerPopup(false);
        setRowToEdit(null);
      }
      } defaultValue={rowToEdit !== null && rows[rowToEdit]}/>
    </Box>
  );
}

export default Question;
